import styled from 'styled-components';
import { CopyStandard } from '../Copytext';
import Icon from '../Icon';

const FilterFlagButton = styled.button`
  ${CopyStandard};
  color: ${(props) => props.theme.color.primary800} !important;
  padding: 8px 20px 8px 15px;
  border: 2px solid ${(props) => props.theme.color.primary800};
  display: flex;
  align-items: center;
  transition:
    opacity 0.5s ease-out,
    transform 0.25s ease-out,
    border-color 0.25s ease-out;

  &:hover {
    border: 2px solid ${(props) => props.theme.color.gray500};
  }
`;

const FilterFlagText = styled.div`
  @media (${(props) => props.theme.searchHero.mobileSwitch}) {
    text-align: left;
  }
`;

const StyledIcon = styled(Icon)`
  color: ${(props) => props.theme.color.primary800};
  width: 13px;
  margin-left: 20px;
`;

/**
 * @param {FilterFlagProps} props
 * @returns {React.ReactElement} The rendered component
 */
const FilterFlag = ({ id, name, handleReset, className }) => (
  <FilterFlagButton className={className} onClick={() => handleReset(id)}>
    <FilterFlagText>{name}</FilterFlagText>
    <StyledIcon icon="CLOSE" />
  </FilterFlagButton>
);

export default FilterFlag;
